export default __webpack_public_path__ + "static/media/bannerEsol1.62e33d92.png";